import React, { useState, useEffect } from "react";
import axios from "axios";
import { saveAs } from "file-saver";
import "./PreFooterFormView.css";
import ContactsHeadercopy from "./ContactsHeadercopy";

const PreFooterFormView = () => {
  const [clientData, setClientData] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");

  // Fetch data from API
  useEffect(() => {
    fetchClientData();
  }, []);

  const fetchClientData = async () => {
    try {
      const response = await axios.get(
        "https://api.dremerz.net/api/Project_17_ManPowerWebsite_Enquiry_Aplication_Form"
      );
      setClientData(response.data);
    } catch (error) {
      console.error("Error fetching client data:", error);
    }
  };

  // Filter Data
  const filteredData = clientData.filter((item) =>
    Object.values(item).some((value) =>
      value.toString().toLowerCase().includes(searchTerm.toLowerCase())
    )
  );

  // Download Filtered Data as CSV
  const handleDownload = () => {
    const csvData = [
      ["Name", "Email ID", "Contact No", "Service Type", "Message", "Date"],
      ...filteredData.map((item) => [
        item.name,
        item.email,
        item.mobile,
        item.serviceType,
        item.message,
        item.date,
      ]),
    ];

    const csvContent = csvData.map((e) => e.join(",")).join("\n");
    const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
    saveAs(blob, "client_data.csv");
  };


  return (
    <>
      <ContactsHeadercopy />
      <div className="container mt-4 ClientForm-admin">
        <h2 className="text-center mb-4">PreFooter Enquiry Form</h2>

        {/* Search Filter */}
        <input
          type="text"
          className="form-control mb-3"
          placeholder="Search by any field..."
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
        />

        {/* Data Table */}
        <div className="table-responsive">
          <table className="table table-striped table-bordered">
            <thead className="thead-dark">
              <tr>
                <th>name</th>
                <th>email</th>
                <th>mobile</th>
                <th>serviceType</th>
                <th>message</th>
                <th>date</th>
              </tr>
            </thead>
            <tbody>
              {filteredData.length > 0 ? (
                filteredData.map((item, index) => (
                  <tr key={index}>
                    <td>{item.name}</td>
                    <td>{item.email}</td>
                    <td>{item.mobile}</td>
                    <td>{item.serviceType}</td>
                    <td>{item.message}</td>
                    <td>{item.date}</td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="10" className="text-center">
                    No Data Available
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>

        {/* Download Button */}
        <button
          className="btn btn-primary"
          onClick={handleDownload}
          disabled={filteredData.length === 0}
        >
          Download Filtered Data
        </button>
      </div>
    </>
  );
};

export default PreFooterFormView;
